import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getIntegration,
}

function getIntegration(partner) {
    return new Promise((resolve) => {
        Superagent
            .get(`${HOST_API}/integrations/${partner}`)
            .set('access', Storage.getItem('access'))
            .end((err, res) => {
                resolve(err ? null : res.body)
            })
    })
}
